const canHavePresets = (channel) => !channel.lsb && channel._defaultPresetTypes

export default canHavePresets
